import React, {
  memo, useMemo,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer, TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';

const defaultRecord = () => ({
});

function PaymentTablePart({
  data, options, onChange, readOnly, currentOrg,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });
  const total = useMemo(
    () => displayedItems
      .reduce((R, row) => R + parseFloat(row.order_amount), 0)
      .toLocaleString('uk', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    [displayedItems],
  );
  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      />
      <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                {fields.payer.label}
              </TableCell>
              <TableCell>
                {fields.contract.label}
              </TableCell>
              <TableCell>
                {fields.payment_number.label}
              </TableCell>
              <TableCell>
                {fields.order_amount.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
                currentOrg={currentOrg}
              />
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell align="right" colSpan={3}>
                Разом:
              </TableCell>
              <TableCell align="right">
                {total}
              </TableCell>
              <TableCell>
                &nbsp;
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  );
}

PaymentTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  currentOrg: PropTypes.number,
};

PaymentTablePart.defaultProps = {
  readOnly: false,
  currentOrg: null,
};

export default memo(PaymentTablePart);
